const recommendedSizes = [
  { width: 8, height: 8 },
  { width: 8, height: 10 },
  { width: 8, height: 12 },
  { width: 8, height: 24 },
  { width: 9, height: 12 },
  { width: 10, height: 8 },
  { width: 10, height: 10 },
  { width: 10, height: 20 },
  { width: 10, height: 30 },
  { width: 11, height: 14 },
  { width: 12, height: 8 },
  { width: 12, height: 9 },
  { width: 12, height: 12 },
  { width: 12, height: 16 },
  { width: 12, height: 18 },
  { width: 12, height: 24 },
  { width: 12, height: 32 },
  { width: 12, height: 36 },
  { width: 14, height: 11 },
  { width: 14, height: 14 },
  { width: 16, height: 12 },
  { width: 16, height: 16 },
  { width: 16, height: 20 },
  { width: 16, height: 24 },
  { width: 16, height: 32 },
  { width: 16, height: 48 },
  { width: 18, height: 12 },
  { width: 18, height: 24 },
  { width: 20, height: 10 },
  { width: 20, height: 16 },
  { width: 20, height: 20 },
  { width: 20, height: 24 },
  { width: 20, height: 28 },
  { width: 20, height: 30 },
  { width: 20, height: 40 },
  { width: 20, height: 60 },
  { width: 24, height: 8 },
  { width: 24, height: 12 },
  { width: 24, height: 16 },
  { width: 24, height: 18 },
  { width: 24, height: 20 },
  { width: 24, height: 24 },
  { width: 24, height: 30 },
  { width: 24, height: 32 },
  { width: 24, height: 36 },
  { width: 24, height: 48 },
  { width: 28, height: 20 },
  { width: 28, height: 40 },
  { width: 30, height: 10 },
  { width: 30, height: 20 },
  { width: 30, height: 24 },
  { width: 30, height: 30 },
  { width: 30, height: 40 },
  { width: 30, height: 60 },
  { width: 32, height: 12 },
  { width: 32, height: 16 },
  { width: 32, height: 24 },
  { width: 32, height: 32 },
  { width: 32, height: 48 },
  { width: 36, height: 12 },
  { width: 36, height: 24 },
  { width: 36, height: 36 },
  { width: 36, height: 48 },
  { width: 40, height: 20 },
  { width: 40, height: 28 },
  { width: 40, height: 30 },
  { width: 40, height: 60 },
  { width: 48, height: 16 },
  { width: 48, height: 24 },
  { width: 48, height: 32 },
  { width: 48, height: 36 },
  { width: 60, height: 20 },
  { width: 60, height: 30 },
  { width: 60, height: 40 }
];

const recommendedHandles = recommendedSizes.map(
  ({ width, height }) => `${height}x${width}`
);
export { recommendedHandles, recommendedSizes };